import React, { useCallback } from 'react';
import { Modal, Spin, Icon } from 'antd';
import useDeleteAttachment from '../../../../mutations/useDeleteAttachment';
import useInfoAttachmentList from '../../../../queries/useInfoAttachmentList';
import useSortAttachmentsByExtensions from '../../../../../../hooks/useSortAttachmentsByExtension';
import PreviewGallery from '../PreviewGallery/PreviewGallery';
import Files from '../Files/Files';
import styles from './AttachmentsContainer.module.scss';

const { confirm } = Modal;

const AttachmentContainer = ({ info }) => {
  const { data: attachmentList, isFetching: isAttachListFetching } =
    useInfoAttachmentList(info.id);

  const { images: rawImages, files } = useSortAttachmentsByExtensions({
    attachments: attachmentList,
  });

  const { deleteAttachmentAsync } = useDeleteAttachment();

  const handleDelete = useCallback(async (file) => {
    const attachId = file['data-attach-id'] || file.id;
    const name = file.name;

    if (attachId) {
      confirm({
        title: 'Удалить вложение?',
        content: <strong>{name}</strong>,
        onOk: async () => {
          await deleteAttachmentAsync({ infoId: info.id, attachId });
        },
        onCancel: () => {},
      });
    }
  }, []);

  return (
    <Spin spinning={isAttachListFetching}>
      <div className={styles.root}>
        <h2 className={styles.title}>
          <Icon type="paper-clip" /> Вложения
        </h2>
        {rawImages.length > 0 && (
          <PreviewGallery
            rawImages={rawImages}
            onDelete={handleDelete}
            infoId={info.id}
          />
        )}
        {files.length > 0 && (
          <Files infoId={info.id} files={files} onDelete={handleDelete} />
        )}
      </div>
    </Spin>
  );
};

export default AttachmentContainer;
